import { TenantProfileWorkStation } from '@models';
import { useStore } from '@stores';
import { formatDateWithOffset } from '@utils';
import dayjs from 'dayjs';
import { useEffect } from 'react';

interface IProps {
  orderId: string | undefined;
  startAt: string | Date | undefined;
  endAt: string | Date | undefined;
}

export const useAvailableWorkStations = ({
  orderId,
  startAt,
  endAt,
}: IProps): TenantProfileWorkStation[] => {
  const { tenantProfileStore } = useStore();
  const { availableWorkStations } = tenantProfileStore;

  useEffect(() => {
    const hasValidRange =
      !!startAt && !!endAt && dayjs(startAt).isValid() && dayjs(endAt).isValid();

    if (orderId && hasValidRange) {
      tenantProfileStore.getAvailableWorkStations({
        orderId,
        orderStartAt: formatDateWithOffset(startAt),
        orderEndAt: formatDateWithOffset(endAt),
      });
    }
    return () => {
      tenantProfileStore.clearAvailableWorkStations();
    };
  }, [tenantProfileStore, orderId, startAt, endAt]);

  return availableWorkStations;
};
